// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3hBhZ","legacyBtn":"MutateMid_legacyBtn__2uXXu"};